import Skeleton from 'components/Skeleton';

import * as S from './styled';

const CopyCodeDesktop = ({ accessCode, isLoading }: { accessCode?: string; isLoading: boolean }) => {
    const formattedAccessCode = accessCode && accessCode.split('').map((ch, i) => <span key={i}>{ch}</span>);

    return (
        <S.DesktopLoginWrapper>
            {isLoading ? (
                <Skeleton height={70} mb={24} />
            ) : (
                <S.AccessCodeBtn data-locator="copyAccessCodeBtn">
                    <S.AccessCode type="h4" medium center mb={2}>
                        {formattedAccessCode}
                    </S.AccessCode>
                </S.AccessCodeBtn>
            )}
        </S.DesktopLoginWrapper>
    );
};

export default CopyCodeDesktop;
